<template>

    <div class="document-container">

        <div v-if="in_progress" class="progress-container">
            <PulseLoader :color="theme_color.main"/>
        </div>

        <div v-else>

            <div v-if="error">{{ error }}</div>
            <div v-else>

                <div class="title-container">
                    <h3 v-if="collection_name=='plazi'" v-html="getTreatmentTitle"/>
                    <h3 v-else v-html="getTitle"/>
                    <p>
                        {{ getId }}.
                        {{ getAuthors }}
                        {{ getDate }}
                        {{ getJournal }}
                        {{ getPublicationTypes }}
                        {{ getLicence }}
                        <ExternalLinks :int_links="int_sources" :ext_links="ext_sources"/>
                    </p>

                </div>
                <ResultsInteractions :interactions="interactions" :collection_name="collection_name" :collection_title="collection_title" mode="fetch"/>

            </div>

        </div>

    </div>




</template>


<script>
import { mapState } from 'vuex'
import axios from 'axios';
var PulseLoader = require('vue-spinner/src/PulseLoader.vue').default;
import ResultsInteractions from '@/components/ResultsInteractions.vue'
import ExternalLinks from '@/components/ExternalLinks.vue'

export default {
  name: 'ResultsDocument',
  components: {
    PulseLoader,
    ResultsInteractions,
    ExternalLinks
  },
  props: {
    doc_id: {
        type: String,
        required: true
    },
    collection_name: {
        type: String,
        required: true
    }
  },
  data() {
    return {
        in_progress: true,
        passages_json: {},
        interactions: [],
        doc_info: {},
        error: null
    };
  },
  computed: {
    ...mapState(['theme_color', 'urls', 'collections']),
    cssVars () {
        return{
            '--color': this.theme_color.main,
        }
    },
    collection_title(){
        return this.collections[this.collection_name]
    },
    int_sources(){
        var encoded_id = encodeURIComponent(this.doc_info._id)
        var sources = []
        if (this.collection_name == "plazi"){
            var linkpla = {}
            linkpla.name = "TreatmentBank"
            linkpla.url = "http://treatment.plazi.org/id/"+this.doc_id
            sources.push(linkpla)
        }
        var linksibils = {}
        linksibils.name = "BiodiversityPMC"
        linksibils.url = "https://biodiversitypmc.sibils.org/collections/"+this.collection_name+"/"+encoded_id
        sources.push(linksibils)
        var linkbiotic = {}
        var url = this.urls.gui
        if (process.env.NODE_ENV != 'production'){
            url = window.location.origin
        }
        linkbiotic.name = "BiotXplorer"
        linkbiotic.url = url+"/collections/"+this.collection_name+"/"+encoded_id
        sources.push(linkbiotic)
        return sources
    },
    ext_sources(){
        var sources = []
        if (this.collection_name == "medline"){
            var linkmed = {}
            linkmed.name = "MEDLINE"
            linkmed.url = "https://pubmed.ncbi.nlm.nih.gov/"+this.doc_id
            sources.push(linkmed)
        }
        return sources
    },
    document_name(){
        if (this.collection_name == "medline"){
            return "PMID"
        }
        else if (this.collection_name == "pmc"){
            return ""
        }
        else if (this.collection_name == "plazi"){
            return "Treatment "
        }
        else if (this.collection_name == "suppdata"){
            return "Supplementary material "
        }
        return "Document "
    },
    getId(){
            if ("_id" in this.doc_info){
                return this.doc_info._id
            }
            else{
                return ""
            }
        },
        getTitle(){
            if ("title" in this.doc_info){
                return this.doc_info.title
            }
            else{
                return ""
            }
        },
        getTreatmentTitle(){
            if ("treatment_title" in this.doc_info){
                return this.doc_info.treatment_title+". "+this.doc_info['article-title']
            }
            else{
                return ""
            }
        },
        getAuthors() {
            if ('authors' in this.doc_info) {
                var authors = []
                if (Array.isArray(this.doc_info.authors)){
                    authors = this.doc_info.authors
                    let authorNames = authors.map(author => {
                        if (typeof author === 'object' && author !== null) {
                            return `${author.last_name} ${author.first_name}`;
                        } else if (typeof author === 'string') {
                            return author;
                        }
                        return ''; // Valeur par défaut si ce n'est ni un objet ni une string
                    }).filter(name => name !== '');
                    authors = authorNames
                }
                else {
                    authors = this.doc_info.authors.split("|")
                }
                if (authors.length <= 7){
                    return authors.join(', ')+". "
                }
                else {
                    return authors.slice(0, 5).join(', ')+ ", et al. "
                }
            }
            else{
                return ""
            }
        },
        getDate() {
            if ('entrez_date' in this.doc_info && this.doc_info.entrez_date != null) {
                return this.doc_info.entrez_date+". "
            }
            else if ('pmc_release_date' in this.doc_info && this.doc_info.pmc_release_date != null)  {
                if ('publication_date' in this.doc_info && this.doc_info.publication_date != this.doc_info.pmc_release_date){
                    return this.doc_info.publication_date +" (released: "+this.doc_info.pmc_release_date+"). "
                }
                else {
                    return this.doc_info.pmc_release_date+". "
                }
            }
            else if ('publication_date' in this.doc_info && this.doc_info.publication_date != null) {
                return this.doc_info.publication_date+". "
            }
            else if ('pubyear' in this.doc_info && this.doc_info.pubyear != null) {
                return this.doc_info.pubyear+". "
            }
            return ""
        },
        getJournal() {
            if ('journal' in this.doc_info) {
                return this.doc_info.journal+". "
            }
            else{
                return ""
            }
        },
        getLicence(){
            if (this.doc_info && 'licence' in this.doc_info && this.doc_info.licence != null) {
                return "Licence "+this.doc_info.licence+". "
            }
            else{
                return ""
            }
        },
        getPublicationTypes() {
            if ('publication_types' in this.doc_info) {
                if (Array.isArray(this.doc_info.publication_types)){
                    return this.doc_info.publication_types.join(",")+". "
                }
                else {
                    return this.doc_info.publication_types.replaceAll('|', ', ')+". "
                }
            }
            else{
                return ""
            }
        },
  },
  methods:{
    fetchDocument(){
        this.in_progress = true
        var url_fetch = this.urls.fetch
        var url = url_fetch+"?collection="+this.collection_name+"&doc_id="+this.doc_id+"&gui"
        axios
            .get(url)
            .then(response => {
                if (!("error" in response.data)){
                    this.error = null
                    this.doc_info = response.data["document"]
                    this.interactions = response.data["triplets"]
                  for (var i=0; i<this.interactions.length; i++){
                    if (this.interactions[i].interaction == "none"){
                        this.interactions[i].interaction = {"preferred_term": "none"}
                    }
                  }
                  this.interactions.sort((a, b) => parseFloat(b.score) - parseFloat(a.score));
              }
              else{
                this.error = response.data["error"]
              }

            })
            .catch(error => {
              alert ("Failed to fetch biotic interactions: "+error)
            })
            .finally(() => this.in_progress = false)
    },
  },
}

</script>


<style scoped lang="scss">

.title-container {
    text-align: left;
    padding: 10px;
    width: 100%;
    background-color: #eee;
    margin: 0
}

.passage-container {
    text-align: justify;
    padding: 10px 0 20px 0;
    margin: 0
}

.info-container {
    text-align: center;
    background-color: #eee;
    color: #000;
    padding: 20px 10px;
    border-radius: 10px;
}

label {
    padding-top: 5px;
    font-weight: bold;
}

a{
    margin-left: 10px;
}

.invert-link-container:hover{
    background-color: #ddd;
    border-radius: 10px;
}


</style>
